import { isSessionOwner } from '../helpers/session-access.js'

export const INTERACTIVE_TUTORIAL_STAGES = Object.freeze({
    INTRO: 'intro',
    HORSE: 'horse',
    RECORD: 'record',
    SYNC: 'sync',
    RESULTS: 'results',
    COMPLETED: 'completed',
    SKIPPED: 'skipped',
})

export const INTERACTIVE_TUTORIAL_FLOW = Object.freeze([
    INTERACTIVE_TUTORIAL_STAGES.INTRO,
    INTERACTIVE_TUTORIAL_STAGES.HORSE,
    INTERACTIVE_TUTORIAL_STAGES.RECORD,
    INTERACTIVE_TUTORIAL_STAGES.SYNC,
    INTERACTIVE_TUTORIAL_STAGES.RESULTS,
])

// Validating the synced session is a step on screen only. The account stays at
// the sync stage until the session is validated, so neither the backend nor an
// older app ever reads a stage it does not know.
export const INTERACTIVE_TUTORIAL_VALIDATION_STEP = 'validation'

// The steps the guide counts on its cards (« Étape 5 sur 6 »).
export const INTERACTIVE_TUTORIAL_STEPS = Object.freeze([
    INTERACTIVE_TUTORIAL_STAGES.INTRO,
    INTERACTIVE_TUTORIAL_STAGES.HORSE,
    INTERACTIVE_TUTORIAL_STAGES.RECORD,
    INTERACTIVE_TUTORIAL_STAGES.SYNC,
    INTERACTIVE_TUTORIAL_VALIDATION_STEP,
    INTERACTIVE_TUTORIAL_STAGES.RESULTS,
])

const KNOWN_STAGES = new Set(Object.values(INTERACTIVE_TUTORIAL_STAGES))

// Missing and unknown values belong to accounts created before the tutorial.
// They must never be enrolled accidentally.
export const normalizeInteractiveTutorialStage = (stage) =>
    KNOWN_STAGES.has(stage) ? stage : INTERACTIVE_TUTORIAL_STAGES.COMPLETED

export const isInteractiveTutorialActive = (stage) =>
    INTERACTIVE_TUTORIAL_FLOW.includes(normalizeInteractiveTutorialStage(stage))

export const nextInteractiveTutorialStage = (stage) => {
    const normalized = normalizeInteractiveTutorialStage(stage)
    const index = INTERACTIVE_TUTORIAL_FLOW.indexOf(normalized)

    if (index < 0) return normalized
    return INTERACTIVE_TUTORIAL_FLOW[index + 1] ?? INTERACTIVE_TUTORIAL_STAGES.COMPLETED
}

export const isProcessedMoveProSession = (session) =>
    Boolean(
        session?.id && ['processed', 'validation'].includes(session?.status) && session?.has_movepro_upload === true
    )

export const isConfirmedUnsyncedMoveProFile = (file) =>
    Boolean(
        file?.properties?.selected === true &&
        file?.properties?.uploadLookup?.status === 'success' &&
        file?.properties?.uploadLookup?.exists === false
    )

export const isEligibleInteractiveTutorialResult = (session, userId) =>
    isProcessedMoveProSession(session) &&
    Boolean(session?.validated) &&
    session?.canEdit === true &&
    // An `owners` that is not a list counts as not owned (isSessionOwner would throw on it).
    Array.isArray(session?.owners) &&
    isSessionOwner(session, userId)
